// extracted by mini-css-extract-plugin
export default {"primaryDeepGreen":"#13211d","primaryPrimeGreen":"#0e442d","primaryBrightGreen":"#9bf9a4","primaryAvardaWhite":"#fffefa","primaryAvardaBlack":"#00110b"};